import { useState } from 'react';
import Header from './Header';
import { Post,LoginURL,forgotPassword,loginWithOtp } from '../utils/api';
import { useNavigate,Link } from 'react-router-dom';
import Button from './../component/Button';
import TextInput from '../component/TextInput.js';
import { wrapComponent } from 'react-snackbar-alert';

const Login = ({createSnackbar}) => {
    const navigate = useNavigate();
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [showPassword,setshowPassword] = useState(false);
    
    const showSnack = (msg='') =>{
        createSnackbar({
            message: msg,
            theme: 'error',
        });
    }

    const forgetPassword = () =>{
        global.Loader(true)
        let config = {
            body:{mobile:username},
            url:forgotPassword
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                navigate(`/loginotp/${username}/forget`);
            }
            else {
                showSnack(res?.message);
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err);
        })
    }


    const userLogin = () =>{
        global.Loader(true)
        let config = {
            body:{input:username,password:password},
            url:LoginURL
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                if(res?.is_verified == 0) {
                    navigate(`/loginotp/${username}`);
                } else {
                    global.dispatch({type:'LOGIN',payload:{token:res?.access_token,data:res?.data}});
                    navigate(`/home`);
                }
            }
            else {
                showSnack(res?.message);
            }
        }).catch((err)=>{
            global.Loader(false)

            console.log(err);
        })
    }



    const sendOtp = () =>{
        global.Loader(true)
        let config = {
            body:{input:username},
            url:loginWithOtp
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                showSnack(res?.message);
                navigate(`/loginotp/${username}`);
            }
            else {
                showSnack(res?.message);
            }
        }).catch((err)=>{
            global.Loader(false)

            console.log(err);
        })
    }

    const UserNameCard = () =>(
        <div>
            <p className="account-heading">or</p>
            {(showPassword)
                ?
                    <TextInput value={password} type="password"  onChange={setPassword} placeholder="Password" />
                :
                    <TextInput value={username} onChange={setUsername} placeholder="Email / Mobile No." />
            }

            <div className="">
                    <Button disable={(username=='')} onClick={()=>{
                        setshowPassword(true);
                    }} title={'Next'} />
                </div>
            {/* <p style={{marginTop:10}} className="signinparatwo">Already registered <Link>Sign In</Link></p> */}
        </div>
    )

    const PasswordCard = () =>(
        <>
            <p className="account-heading">or</p>
            {(showPassword)
                ?
                    <TextInput value={password} type="password"  onChange={setPassword} placeholder="Password" />
                :
                    <TextInput value={username} onChange={setUsername} placeholder="Email / Mobile No." />
            }

            <div className='row' style={{justifyContent:'center'}}>
                <Button style={{width:'25%',marginRight:60}} onClick={()=>{
                    navigate(-1);
                }} title={'back'} />
                <Button backgroundColor={'#219653'} disable={(password=='')} onClick={()=>{
                    userLogin();
                }} style={{width:'25%'}} title={'Login'} />
            </div>
            <p className="signinparaone" onClick={forgetPassword}><Link>Forgot your Password?</Link></p>
            <p className="signinparatwo">Reset It or <span style={{textDecoration:'underline'}} onClick={sendOtp}>LogIn with OTP</span></p>
            <p className="signinparathree"><Link>Terms & Conditions</Link></p>
        </>
    )

    
    return (
        <div className="best">
            <Header />
            <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li style={{paddingLeft:5}}> Sign In</li>
                </ul>
            </div>
        </div>

        <div className="wrapbox">
            <div className="wrapper">
                <div className="heading">
                    <h5>Sign in with</h5>
                </div>
                <div className="social">
                    <a href="#" className="social-links"><img style={{height:18,width:18}} src="/images/search.png"/> Google</a>
                    <a href="#" className="social-links"><img style={{height:18,width:18}} src="/images/facebook.png"/> Facebook</a>
                </div>
                {(showPassword)?
                    PasswordCard()
                :
                    UserNameCard()
                }
            </div>
        </div>
        </div>
    );
};
  
export default wrapComponent(Login);
